// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2dP-K","rootCenter":"LoadMoreObserver_rootCenter__3N4S_","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3bTKQ"};